import { render, staticRenderFns } from "./imgK.vue?vue&type=template&id=d3484ba8"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3484ba8')) {
      api.createRecord('d3484ba8', component.options)
    } else {
      api.reload('d3484ba8', component.options)
    }
    module.hot.accept("./imgK.vue?vue&type=template&id=d3484ba8", function () {
      api.rerender('d3484ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgK.vue"
export default component.exports